import { render, staticRenderFns } from "./orderPharmacy.vue?vue&type=template&id=d6fc3c2c&scoped=true"
import script from "./orderPharmacy.vue?vue&type=script&lang=js"
export * from "./orderPharmacy.vue?vue&type=script&lang=js"
import style0 from "./orderPharmacy.vue?vue&type=style&index=0&id=d6fc3c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fc3c2c",
  null
  
)

export default component.exports